import { connect } from 'react-redux';

import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectTotalProducts } from 'src/redux/products/selectors/selectors';
import { selectActiveFacets } from 'src/redux/productsQuery/selectors/selectors';
import { SearchListing } from './SearchListing';

const mapStateToProps = (state: ReduxApplicationState, ownProps: { stickyTopBanner?: boolean }) => {
  const showProductsList =
    !state.products.error &&
    (selectTotalProducts(state) > 0 || selectActiveFacets(state).length > 0);

  return {
    products: state.products,
    pageLiveRegionText: state.accessibility.statusMessage,
    showProductsList,
    stickyTopBanner: ownProps.stickyTopBanner ?? false,
  };
};

export const SearchListingContainer = connect(mapStateToProps)(SearchListing);
